module.exports = __webpack_public_path__ + "assets/img/notPic.c476456e.jpg";